export class UploadFileMasterDataParseError {

    public cellValue: any;
    public column: number;
    public columnName: string;
    public message: string;
    public row: number;

    static fromDto(data: any): UploadFileMasterDataParseError {
        if (!data) {
          return null;
        }

        const parseError = new UploadFileMasterDataParseError();

        parseError.cellValue   = data.cellValue;
        parseError.column = data.column;
        parseError.columnName    = data.columnName;
        parseError.message      = data.message;
        parseError.row     = data.row;

        return parseError;
      }

      static toDtos(data: UploadFileMasterDataParseError[]) {
        return data.map(d => ({
            cellValue: d.cellValue,
            column: d.column,
            columnName: d.columnName,
            message: d.message,
            row: d.row
        }));
      }

}
